'use strict';

helpService.$inject = ["$http", "HelpItem", "localizer", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.helpService = helpService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function helpService($http, HelpItem, localizer, authService) {
    return {
        getHelpCategories: getHelpCategories,
        getHelpSubCategory: getHelpSubCategory
    };

    function getHelpCategories() {
        var currentLanguage = localizer.getCurrentLanguage() ? localizer.getCurrentLanguage() : 'nl';
        var urlString = '';

        if (authService.isFebelcoCustomer) {
            urlString = '/assets/data/help-' + currentLanguage + '.json';
        } else {
            urlString = '/assets/data/help-nonfp-' + currentLanguage + '.json';
        }

        return $http.get(urlString).then(function (response) {
            return _lodash2.default.map(response.data.help, function (i) {
                return HelpItem.create(i);
            });
        });
    }

    function getHelpSubCategory(categoryId) {
        var currentLanguage = localizer.getCurrentLanguage() ? localizer.getCurrentLanguage() : 'nl';
        var urlString = '';

        if (authService.isFebelcoCustomer) {
            urlString = '/assets/data/help-' + currentLanguage + '.json';
        } else {
            urlString = '/assets/data/help-nonfp-' + currentLanguage + '.json';
        }

        return $http.get(urlString).then(function (response) {
            return HelpItem.create(_lodash2.default.find(response.data.help, function (item) {
                return item.categoryId === categoryId;
            }));
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/helpService.js
// module id = 813
// module chunks = 0